export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/CO-ae5f36bce8454ace76050c2cbc2c617a.png";